import type { SupportLayerProvider } from '@creditornot/support-layer';
import type { ComponentProps } from 'react';

import {
  supportLayerImpressionContactSupport,
  supportLayerImpressionSupportLayerOption,
  supportLayerInteractionCloseSupportLayer,
  supportLayerInteractionContactSupport,
  supportLayerInteractionGoToPreviousNode,
  supportLayerInteractionSupportLayerOption,
  supportLayerView,
} from 'core/telemetry/avo/Avo';

type SupportLayerProviderProps = ComponentProps<typeof SupportLayerProvider>;

export const handleTelemetryEvent: SupportLayerProviderProps['onTelemetryEvent'] = ({ type, payload }) => {
  if (type === 'support_layer_impression_support_layer_option') {
    supportLayerImpressionSupportLayerOption(payload);
    return;
  }

  if (type === 'support_layer_interaction_support_layer_option') {
    supportLayerInteractionSupportLayerOption(payload);
    return;
  }

  if (type === 'support_layer_interaction_go_to_previous_node') {
    supportLayerInteractionGoToPreviousNode(payload);
    return;
  }

  if (type === 'support_layer_interaction_close_support_layer') {
    supportLayerInteractionCloseSupportLayer(payload);
    return;
  }

  if (type === 'support_layer_interaction_contact_support') {
    supportLayerInteractionContactSupport(payload);
    return;
  }

  if (type === 'support_layer_impression_contact_support') {
    supportLayerImpressionContactSupport(payload);
    return;
  }

  if (type === 'support_layer_view') {
    const { renderedAt: _, duration, ...restPayload } = payload;

    supportLayerView({
      ...restPayload,
      supportLayerOpenDurationMs: duration,
    });

    return;
  }
};
